// extracted by mini-css-extract-plugin
export default {"modalHeader":"SessionManagementModal_modalHeader__mMOWp","modalBody":"SessionManagementModal_modalBody__YJBda"};